import { render, staticRenderFns } from "./AlarmStatsDashboard.vue?vue&type=template&id=8fb72a70"
import script from "./AlarmStatsDashboard.vue?vue&type=script&lang=js"
export * from "./AlarmStatsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports